import React  from 'react';
import PropTypes from 'prop-types';

import SelectEstimate from "core/gd-ui/select-estimate/task/estimate";

export default function EstimateInList(props) {

    return (
        <SelectEstimate renderValue="text-13"
                        underlined="on-hover"
                        value={props.listItem.estimated.own}
                        childrenValue={props.listItem.estimated.children}
                        showSummary={props.listItem.isCollapsed && props.listItem.childrenItems.length > 0 && !!props.listItem.estimated.children}
                        placeholder="Estimate"
                        attachment="middle right"
                        targetAttachment="middle left"
                        disabled={props.disabled}
                        onUserSelect={props.onUserSelect}
                        deleteButton={false} />
    );
}

EstimateInList.propTypes = {
    item: PropTypes.object,
    listItem: PropTypes.object,

    disabled: PropTypes.bool,

    onUserSelect: PropTypes.func
};